module.exports = __webpack_public_path__ + "static/img/mood1.f90d7e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood1.png
// module id = 7dlP
// module chunks = 1